//Количество символов
export default {
    methods: {
        enumFilterMap(type, value, lib) {
            //value - значение которое необходимо перевести
            //lib - варианты для мапинга
            let mapResult = ''

            if (type === 'get') {
                //При получении данных
                lib.forEach(item => {
                    if (item.value === value) {
                        mapResult = item.name
                    }
                })
            }

            if (type === 'send') {
                //При получении данных
                lib.forEach(item => {
                    if (item.value === value) {
                        mapResult = item.value
                    }
                })
            }

            return mapResult
        }
    }
}